// extracted by mini-css-extract-plugin
export default {"logo":"headerSimple_logo__GOsHx"};